import { PayloadAction } from '@reduxjs/toolkit';
import type { ThunkMiddleware } from './types';

import ClientApi from '~/clientApi';
import { setWorldRendererState } from '~/store/app';
import { appReducerActions } from '~/store/appSlice';
import { dialogsReducerActions } from '~/store/dialogsSlice';


const dialogsListeneMiddleware: ThunkMiddleware = (store: GlobalStore) => (next) => <P>(
    action: (PayloadAction<P & { skipMiddleware?: boolean }>) | ((...args: unknown[]) => void)
) => {
    if (typeof action === 'function') {
        return action(store.dispatch, store.getState);
    }

    if (action?.payload?.skipMiddleware) {
        return next(action);
    }

    const state = store.getState();
    const { dispatch } = store;

    if (action.type.includes('Dialog')) {
        if (window.tooltipProvider) {
            window.tooltipProvider.hide();
        }
        if (action.type.includes('dialogs/open')) {
            ClientApi.setDialogState(true);
            ClientApi.setScrollover(true);
            ClientApi.switchWorldRendererState(false);
        }
        if (action.type.includes('dialogs/close')) {
            ClientApi.setDialogState(false);
            if (!state.dialogs.isBlueprintsViewerVisible) {
                ClientApi.setScrollover(false);
                ClientApi.switchWorldRendererState(true);
            }
        }
    }

    if (action.type === dialogsReducerActions.showVideoPlayer.type) {
        ClientApi.setDialogState(true);
        ClientApi.switchSoundState(false);
        ClientApi.setScrollover(true);
        ClientApi.switchWorldRendererState(false);
    }
    if (action.type === dialogsReducerActions.hideVideoPlayer.type) {
        ClientApi.setDialogState(false);
        ClientApi.switchSoundState(true);
        if (!state.dialogs.isBlueprintsViewerVisible) {
            dispatch(setWorldRendererState(true));
            ClientApi.setScrollover(false);
            ClientApi.switchWorldRendererState(true);
        }
    }
    if (action.type === appReducerActions.turnGuideOn.type) {
        ClientApi.setDialogState(true);
        ClientApi.setScrollover(true);
    }
    if (action.type === appReducerActions.turnGuideOff.type) {
        ClientApi.setDialogState(false);
        if (!state.dialogs.isBlueprintsViewerVisible) {
            ClientApi.setScrollover(false);
        }
    }

    return next(action);
};

export default dialogsListeneMiddleware;
